import CityPageTemplate from "../city-template/CityPageTemplate";
import { fairfaxVaConfig } from "./data";

export default function FairfaxVaPage() {
  return <CityPageTemplate config={fairfaxVaConfig} />;
}